// the form field attributes:
const FIELDS = [
    { label: "Title", name: "name[title]" },
    { label: "First name", name: "name[first]" },
    { label: "Last name", name: "name[last]" },
    { label: "Enter Email", name: "email" },
    { label: "Country", name: "location[country]" },
    { label: "City", name: "location[city]" },
    { label: "Street", name: "location[street][name]" },
    { label: "Number", name: "location[street][number]" },
];

export default FIELDS;